var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoStar = function SvgIcoStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none",
    viewBox: "0 0 22 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 17.413-5.483 2.893a.733.733 0 0 1-1.065-.772L5.5 13.402 1.059 9.057a.733.733 0 0 1 .407-1.25l6.135-.894 2.741-5.575a.733.733 0 0 1 1.316 0L14.4 6.913l6.135.894c.6.088.841.826.407 1.25L16.5 13.402l1.048 6.132a.733.733 0 0 1-1.065.772z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoStar;